//@ts-check
import React from 'react';
import useFormDataLayer from '../logic/useFormDataLayer';
import useFormApi from '../logic/useFormAPI';
import FormField from './Field';
import Subscriptions from '../fields/Subscriptions';
import fieldsLogic from '../logic/fieldsLogic';
/**
 * @param {any} value
 * @returns {Array<import('./types').SubscriptionValue>}
 */

var parseValue = function parseValue(value) {
  var result = [];
  if (!value) return result;
  var parts = value.split(';');
  if (!parts || !parts.length) return [];
  parts.forEach(function (part) {
    var subscriptionPart = part.replace('{', '').replace('}', '');
    if (!subscriptionPart) return;
    var subscriptionParts = subscriptionPart.split(',');
    if (subscriptionParts.length !== 2) return;
    var id = parseInt(subscriptionParts[0].replace('id=', ''));
    var subscribed = subscriptionParts[1].replace('subscribed=', '') === 'true';
    result.push({
      id: id,
      subscribed: subscribed
    });
  });
  return result;
};
/**
 * @param {Array<import('../logic/data/types').Subscription>} availableSubscriptions
 * @param {Array<import('./types').SubscriptionValue>} subscriptions
 */


var createSubscriptionOptions = function createSubscriptionOptions(availableSubscriptions, subscriptions) {
  if (!availableSubscriptions || !availableSubscriptions.length) return [];
  return availableSubscriptions.map(function (availableSubscription) {
    var subscriptionId = availableSubscription.id;
    var subscription = subscriptions.find(function (s) {
      return s.id === subscriptionId;
    });
    var subscribed = subscription ? subscription.subscribed : availableSubscription.defaultValue;
    return {
      value: subscriptionId,
      label: availableSubscription.name,
      checked: subscribed
    };
  });
};
/**
 *
 * @param {Array<import('./types').SubscriptionValue>} subscriptions
 * @param {number} subscriptionId
 * @param {boolean} subscribed
 */


var getSubscriptionsValue = function getSubscriptionsValue(subscriptions, subscriptionId, subscribed) {
  var value = "{id=".concat(subscriptionId, ",subscribed=").concat(subscribed, "}");
  subscriptions.forEach(function (s) {
    if (s.id.toString() === subscriptionId.toString()) return; // already added above

    value += ";{id=".concat(s.id, ",subscribed=").concat(s.subscribed, "}");
  });
  return value;
};

var ConnectedSubscriptionsField = function ConnectedSubscriptionsField(_ref) {
  var fieldId = _ref.fieldId;
  var fieldData = useFormDataLayer(fieldId);

  var _useFormApi = useFormApi(),
      state = _useFormApi.state;

  var value = fieldData.value,
      dispatch = fieldData.dispatch,
      error = fieldData.error,
      active = fieldData.active,
      description = fieldData.description;
  var labelPlacement = fieldData.labelPlacement,
      caption = fieldData.caption,
      required = fieldData.required,
      readonly = fieldData.readonly;
  var availableSubscriptions = state.context.subscriptions;
  var subscriptions = parseValue(value);
  var options = createSubscriptionOptions(availableSubscriptions, subscriptions);

  var onChange = function onChange(subscriptionId, subscribed) {
    var newValue = getSubscriptionsValue(subscriptions, subscriptionId, subscribed);
    fieldsLogic.onChange(fieldId, newValue, dispatch);
  };

  return React.createElement(FormField, {
    label: caption,
    labelPlacement: labelPlacement || 'left',
    required: required
  }, React.createElement(Subscriptions, {
    placeholder: "No preferences defined in Ecrion.",
    active: active,
    fieldId: fieldId,
    options: options,
    readonly: readonly,
    dispatch: dispatch,
    onChange: onChange,
    error: error,
    description: description
  }));
};

export default React.memo(ConnectedSubscriptionsField);